interface StatusBadgeProps {
  status: string;
  className?: string;
}

interface BadgeStyle {
  label: string;
  bgClass: string;
  textClass: string;
  dotClass: string;
}

const BADGE_MAP: Record<string, BadgeStyle> = {
  operational: {
    label: "Operational",
    bgClass: "bg-emerald-100",
    textClass: "text-emerald-800",
    dotClass: "bg-emerald-500",
  },
  degraded: {
    label: "Degraded",
    bgClass: "bg-amber-100",
    textClass: "text-amber-800",
    dotClass: "bg-amber-500",
  },
  partial_outage: {
    label: "Partial Outage",
    bgClass: "bg-orange-100",
    textClass: "text-orange-800",
    dotClass: "bg-orange-500",
  },
  major_outage: {
    label: "Major Outage",
    bgClass: "bg-red-100",
    textClass: "text-red-800",
    dotClass: "bg-red-500",
  },
  maintenance: {
    label: "Maintenance",
    bgClass: "bg-indigo-100",
    textClass: "text-indigo-800",
    dotClass: "bg-indigo-500",
  },
  investigating: {
    label: "Investigating",
    bgClass: "bg-yellow-100",
    textClass: "text-yellow-800",
    dotClass: "bg-yellow-500",
  },
  identified: {
    label: "Identified",
    bgClass: "bg-orange-100",
    textClass: "text-orange-800",
    dotClass: "bg-orange-500",
  },
  monitoring: {
    label: "Monitoring",
    bgClass: "bg-blue-100",
    textClass: "text-blue-800",
    dotClass: "bg-blue-500",
  },
  resolved: {
    label: "Resolved",
    bgClass: "bg-emerald-100",
    textClass: "text-emerald-800",
    dotClass: "bg-emerald-500",
  },
  unknown: {
    label: "Unknown",
    bgClass: "bg-gray-100",
    textClass: "text-gray-700",
    dotClass: "bg-gray-400",
  },
};

function formatLabel(status: string): string {
  return status
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  const style = BADGE_MAP[status] ?? {
    label: formatLabel(status),
    bgClass: "bg-gray-100",
    textClass: "text-gray-700",
    dotClass: "bg-gray-400",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${style.bgClass} ${style.textClass} ${className}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${style.dotClass}`}
        aria-hidden="true"
      />
      {style.label}
    </span>
  );
}
